import { isEmpty } from 'radash';
import { IPopularCollection, IRecipeItem } from '@modules/collections/domain/models/popularCollection.model';
import { PopularCollectionResponse, RecipeResponse } from '@modules/libs/graphql/generated/graphql';
export class PopularCollectionEntityMapper {
  public static toDomain(popularCollectionResponse: PopularCollectionResponse): IPopularCollection {
    return {
      id: popularCollectionResponse.id,
      name: popularCollectionResponse.title,
      nameColor: popularCollectionResponse.colorTitlePopular,
      menuAmount: popularCollectionResponse.recipeListTotal ?? 0,
      menuAmountColor: popularCollectionResponse.colorMenuPopular,
      backgroundImage: popularCollectionResponse.thumbPopular,
      recipeList: this.recipeListMapper(popularCollectionResponse.recipeList)
    };
  }
  private static recipeListMapper(recipeList: RecipeResponse[]): IRecipeItem[] {
    return recipeList.map(recipe => {
      return {
        id: recipe.id,
        name: recipe.title,
        imageUrl: recipe.thumbUrl,
        slug: isEmpty(recipe.slugUrl) ? recipe.id.toString() : recipe.slugUrl
      };
    });
  }
}